export const TESTIMONIALS = {
  Sleep: {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "SLEEP OPTIMIZATION",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "Falling asleep was always a struggle. Now I wake up feeling rested, clear-headed, and ready to take on the day.",
    maleQuote:
      "I used to crash hard but still wake up groggy. These supplements help me get deeper, uninterrupted sleep, and I wake up feeling ready.",
  },
  "Gut Health": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "GUT HEALTH",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "My bloating and discomfort are finally under control. I feel lighter, more energized, and way more comfortable day to day.",
    maleQuote:
      "I didn’t realize how much gut issues were affecting my energy. Since starting this stack, I feel way more consistent.",
  },
  "Stress Support": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "STRESS SUPPORT",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "The stress and anxiety used to be constant. With the right support, I feel calm and in control again.",
    maleQuote:
      "I used to carry tension in my body all day. Now I’m finally able to unwind, even after tough meetings.",
  },
  "Focus & Clarity": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "FOCUS & CLARITY",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "Mental fog is gone. I can finally concentrate and power through my day with clarity and ease.",
    maleQuote:
      "I’m more locked in at work and way less distracted. It’s made a big difference in how I show up professionally.",
  },
  Immunity: {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "IMMUNITY",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "My immune system feels so much stronger. I haven’t had a sick day in months.",
    maleQuote:
      "I used to get sidelined by colds all the time. Since I started this stack, I bounce back faster and feel more resilient.",
  },
  "Skin & Hair": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "SKIN & HAIR",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    maleQuote:
      "People actually notice my skin now. It’s clearer, and my hair feels thicker and healthier.",
    femaleQuote:
      "My skin glows, and I finally feel confident going makeup-free.",
  },
  Energy: {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "ENERGY",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "I’m more energized in the mornings and don’t need multiple cups of coffee to function anymore.",
    maleQuote:
      "No more afternoon crashes. I’ve got steady energy all day — even after long workouts.",
  },
  Detox: {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "DETOX",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "I feel lighter and more refreshed. Like I reset my system in a way I didn’t know I needed.",
    maleQuote:
      "Supporting my detox pathways gave me a noticeable lift in energy and focus. I just feel cleaner inside.",
  },
  "Hormonal Balance": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "HORMONAL BALANCE",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "Balancing my hormones changed everything. I feel more emotionally steady and in sync.",
    maleQuote:
      "Once I got my hormones in check, everything started working better — mood, energy, even workouts.",
  },
  "Joint Support": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "JOINT SUPPORT",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "My joints feel better and I’m back to doing the things I love without discomfort.",
    maleQuote:
      "I’m back to running pain-free. These supplements really helped my knees and overall mobility.",
  },
  "Mood Support": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "MOOD SUPPORT",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "I feel lighter and more emotionally balanced. It’s like I got my spark back.",
    maleQuote:
      "I feel more even throughout the day — less reactive, more grounded. It’s been a huge shift.",
  },
  "Weight Support": {
    femaleName: "Jane D.",
    maleName: "John S.",
    goal: "WEIGHT SUPPORT",
    maleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.19.51_PM.png",
    femaleImage:
      "https://cdn.shopify.com/s/files/1/0279/9910/9251/files/Screenshot_2025-03-29_at_6.24.55_PM.png",
    femaleQuote:
      "The supplements helped me curb cravings and stay energized during my weight loss journey.",
    maleQuote:
      "This stack gave me the energy and appetite control to stay consistent and actually see results.",
  },
};
